module.exports = __webpack_public_path__ + "src/assets/img/inear_de.a4a1ea50.png";